import { Button, Typography, Hidden, IconButton, Popper, ClickAwayListener, Paper } from '@material-ui/core';
import React, {ReactFragment, useState} from 'react';

interface Props {
    buttonText:string;
    displayBody: ReactFragment;
    icon: ReactFragment;
}

export function DropDownButton(props: Props) {
    const { displayBody, buttonText, icon} = props;
    const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>()
    
    return (
        <>
            <Hidden mdDown >
                <Button
                    onClick={(e: any) => setAnchorEl(e.currentTarget)}
                    style={{ backgroundColor: anchorEl !== undefined ? "rgba(0, 0, 0, 0.08)" : undefined }}
                >
                    <Typography color="inherit">{buttonText.toLocaleUpperCase()}</Typography>
                </Button>
            </Hidden>
            <Hidden lgUp>
                <IconButton
                    onClick={(e: any) => setAnchorEl(e.currentTarget)}
                    style={{ backgroundColor: anchorEl !== undefined ? "rgba(0, 0, 0, 0.08)" : undefined }}
                >
                    {icon}
                </IconButton>
            </Hidden>
            <Popper
                id="menu-focused"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                placement="bottom-end"
                onClick={() => setAnchorEl(undefined)}
                style={{zIndex:1500}}
            >
                <ClickAwayListener onClickAway={() => setAnchorEl(undefined)}>
                    <Paper elevation={2}>
                    <span style={{ outline: "none" }}>
                        {displayBody}
                    </span>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        </>
    );
}